import styled from 'styled-components';

import { LandingHero } from 'constants/landing-hero';

import { drift, floatA, floatB } from './keyframes';

export const Layer = styled.div`
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;
`;

export const Grid = styled.div`
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(${LandingHero.gridLine} 0.1rem, transparent 0.1rem),
    linear-gradient(90deg, ${LandingHero.gridLine} 0.1rem, transparent 0.1rem);
  background-size: 6.4rem 6.4rem;
  -webkit-mask-image: radial-gradient(
    ellipse 60% 45% at 50% 22%,
    #000 30%,
    transparent 75%
  );
  mask-image: radial-gradient(
    ellipse 60% 45% at 50% 22%,
    #000 30%,
    transparent 75%
  );
  animation: ${drift} 14s linear infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const OrbGreen = styled.div`
  position: absolute;
  top: 24rem;
  left: -12rem;
  width: 52rem;
  height: 52rem;
  border-radius: 50%;
  background: ${LandingHero.orbGreen};
  opacity: 0.16;
  filter: blur(12rem);
  animation: ${floatA} 16s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const OrbSky = styled.div`
  position: absolute;
  top: 10rem;
  right: -14rem;
  width: 56rem;
  height: 56rem;
  border-radius: 50%;
  background: ${LandingHero.orbSky};
  opacity: 0.18;
  filter: blur(13rem);
  animation: ${floatB} 19s ease-in-out infinite;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
